import { OnInit, OnDestroy, Component } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CoreConfigService } from "@core/services/config.service";
import packageJson from "../../../../../package.json";
import { UtilsService } from "../../../auth/service/utils.service";
import moment from "moment";

@Component({
  selector: "footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit, OnDestroy {
  public coreConfig: any;

  public year: number = new Date().getFullYear();
  public currentDay: number = Number(moment().format('DD'));
  // Private
  private _unsubscribeAll: Subject<any>;
  public maintenanceTodayOrTomorrow: boolean = false;
  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {UtilsService} _utilsService
   */
  constructor(
    public _coreConfigService: CoreConfigService,
    public _utilsService: UtilsService,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.coreConfig = config;
    });
    if (this._utilsService.isMaintenance) {
      //Manutenzione oggi o domani
      if (
        Number(this._utilsService.formatDate(this._utilsService.themeConfiguration.maintenance_start, "DD")) === this.currentDay ||
        Number(this._utilsService.formatDate(this._utilsService.themeConfiguration.maintenance_start, "DD")) === this.currentDay + 1
      ) {
        this.maintenanceTodayOrTomorrow = true;
      }
    }
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  getVersion() {
    return packageJson.version;
  }

  protected readonly Number = Number;
}
